import React, { FC } from "react";

const SectionContent: FC = ({ children }) => (
  <div className="w-3/4">{children}</div>
);

export default SectionContent;
